import { AppState, ConfiguratorType, StateChangeListener } from './types';

// ─── Internal state ────────────────────────────────────────────────────────

const _state: AppState = {
  activeConfigurator: 'furniture',
  currentModel: null,
  isLoading: false,
  currentColor: '#4fc3f7',
  furnitureColor: '',           // default: GLB natural colours (no override)
  furnitureVariant: 'premium',
};

const _listeners: StateChangeListener[] = [];

// ─── Public API ────────────────────────────────────────────────────────────

/** Read current state (frozen snapshot). */
export function getState(): Readonly<AppState> {
  return _state;
}

/** Merge a partial update and notify all subscribers. */
export function setState(partial: Partial<AppState>): void {
  Object.assign(_state, partial);
  _notify();
}

/**
 * Subscribe to state changes.
 * Returns an unsubscribe function — call it to clean up.
 */
export function subscribe(listener: StateChangeListener): () => void {
  _listeners.push(listener);
  return () => {
    const idx = _listeners.indexOf(listener);
    if (idx !== -1) _listeners.splice(idx, 1);
  };
}

function _notify(): void {
  const snapshot = Object.freeze({ ..._state });
  _listeners.forEach((fn) => fn(snapshot));
}
